import { useTranslation } from 'react-i18next';
import { SidebarLayoutHeader } from '~/layout/components/sidebar-layout-header/SidebarLayoutHeader';
import { StandardHeader } from '~/layout/components/standard-header/StandardHeader';

export interface ChatHeaderProps {}

export const ChatHeader = ({}: ChatHeaderProps) => {
  const { t } = useTranslation('chat');

  return (
    <SidebarLayoutHeader>
      <StandardHeader
        subtitle={t('header.subtitle')}
        title={t('header.title')}
      />
    </SidebarLayoutHeader>
  );
};
